import Carousel from './Carousel';

export default Carousel;



// WEBPACK FOOTER //
// ./src/carousel/index.js